import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

import { CaseStatusBadge } from './CaseStatusBadge';

interface CaseCardProps {
  caseId: string;
  event: string;
  status: string;
  programCode: string;
  progression: string;
  tier: string;
  manager: string;
  organization: string;
  onManage?: () => void;
}

export function CaseCard({
  caseId,
  event,
  status,
  programCode,
  progression,
  tier,
  manager,
  organization,
  onManage,
}: CaseCardProps) {
  return (
    <Card sx={{ mb: (t) => t.spacing(1.5) }}>
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: (t) => t.spacing(0.5) }}>
            <Typography variant="subtitle2">{event}</Typography>
            <CaseStatusBadge status={status} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap' }}>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Case:</strong> {caseId}
            </Typography>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Program:</strong> {programCode}
            </Typography>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Progression:</strong> {progression}
            </Typography>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Tier:</strong> {tier}
            </Typography>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Manager:</strong> {manager}
            </Typography>
            <Typography variant="caption" sx={{ color: (t) => t.palette.text.secondary }}>
              <strong>Organization:</strong> {organization}
            </Typography>
          </Stack>
        </Box>
        <Button variant="outlined" size="small" onClick={onManage}>
          Manage case
        </Button>
      </CardContent>
    </Card>
  );
}
